const GetInTouch = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_708_31766)">
      <path
        d="M24 48C37.25 48 48 37.26 48 24C48 10.74 37.25 0 24 0C10.75 0 0 10.74 0 24C0 37.26 10.74 48 24 48Z"
        fill="#999999"
      />
      <path
        d="M19.8904 37.0501C28.7214 37.0501 35.8804 29.8911 35.8804 21.0601C35.8804 12.229 28.7214 5.07007 19.8904 5.07007C11.0594 5.07007 3.90039 12.229 3.90039 21.0601C3.90039 29.8911 11.0594 37.0501 19.8904 37.0501Z"
        fill="black"
      />
      <path
        d="M26.9697 35.8999C30.8797 40.0599 37.3597 41.5599 42.6897 39.5399C39.1497 38.7999 35.9297 36.6499 33.8897 33.6699"
        fill="white"
      />
      <path
        d="M12.4701 27.5201C9.58008 30.6001 4.78008 31.7101 0.830078 30.2201C3.45008 29.6701 5.83008 28.0801 7.34008 25.8701"
        fill="black"
      />
      <path
        d="M24.1296 40.3699C32.9607 40.3699 40.1196 33.2109 40.1196 24.3799C40.1196 15.5489 32.9607 8.38989 24.1296 8.38989C15.2986 8.38989 8.13965 15.5489 8.13965 24.3799C8.13965 33.2109 15.2986 40.3699 24.1296 40.3699Z"
        fill="white"
      />
      <path
        d="M11.4295 26.8399C14.4495 26.1899 17.5495 25.4699 20.1895 23.7999C22.3495 22.4399 25.8695 19.1999 24.8295 16.2999C24.3195 14.8699 22.8295 14.0799 21.3595 14.1999C19.7395 14.3399 18.1895 15.5899 17.0795 16.6899C14.6595 19.0899 12.4895 23.0699 13.2795 26.5799C14.0095 29.8299 17.4695 31.5299 20.5495 31.6399C22.7795 31.7199 24.9895 30.8299 26.9795 29.8999C28.7495 29.0699 31.3695 27.6299 31.2895 25.3299C31.1795 22.3899 27.7795 22.0199 25.8695 23.4899C24.5995 24.4599 23.6795 26.0599 23.6495 27.6799C23.6095 29.4499 24.7895 31.0899 26.1795 32.0899C29.1995 34.2599 33.9695 32.8199 36.4195 30.4099C37.4495 29.3899 35.8595 27.7999 34.8295 28.8199C33.3195 30.2999 30.5895 31.3299 28.4695 30.7599C26.1295 30.1299 25.1695 27.4299 26.8295 25.6399C27.2095 25.2299 28.0495 24.5599 28.6595 24.8499C29.1395 25.0799 29.0895 25.5299 28.8695 25.8999C28.1695 27.0899 26.3095 27.7899 25.1095 28.2899C23.9095 28.7899 22.5395 29.3299 21.1995 29.3899C19.1995 29.4799 16.6395 28.7299 15.7195 26.7699C14.5995 24.4199 16.2295 21.2999 17.6595 19.4399C18.3895 18.4799 19.2895 17.6199 20.3195 16.9899C21.0595 16.5299 23.0795 15.9799 22.7395 17.6099C22.4995 18.7399 21.3995 19.9199 20.5995 20.6799C19.7495 21.4799 18.7395 22.0999 17.6895 22.6099C15.5395 23.6499 13.1595 24.1599 10.8395 24.6599C9.41953 24.9599 10.0195 27.1299 11.4395 26.8299L11.4295 26.8399Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_708_31766">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GetInTouch;
